export default __webpack_public_path__ + "static/Locations-2fd66ae155a3ee09ad36d88c86e7e910.png";